module.exports = __webpack_public_path__ + "images/vehicle-point.7d44aac32e8e2134b1e0f429e02a8ce9.svg";